<template>
  <!-- 添加/修改项目成员组 -->
  <zl-dialog class="zl-saas" title="新增成员分组" ref="dialog" width="665px" :close-on-click-modal="false">
    <el-form :model="form" :rules="rules" label-width="100px" ref="form">
      <el-form-item label="分组名称:" prop="name">
        <el-input v-model="form.name" style="width:328px"></el-input>
      </el-form-item>
      <el-form-item label="选择成员:" prop="chengYuanGuids">
        <member-select-by-tree
          v-model="checkedMember"
          width="328px"
        ></member-select-by-tree>
      </el-form-item>
      <el-form-item label="适用范围:">
        <el-row :gutter="20" style="width:328px">
          <el-col :span="10">
            <div v-for="(value, name) in enums.subSystem" :key="name">
              <el-checkbox
                :label="value"
                v-model="subSystemObj[name].checked"
                disabled
              ></el-checkbox>
            </div>
          </el-col>
          <el-col :span="10">
            <div v-for="(value, name) in enums.subSystem" :key="name">
              <el-checkbox
                label="是否设置为默认读取"
                v-model="subSystemObj[name].default"
              ></el-checkbox>
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input v-model="form.remark" style="width:328px"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button size="small" plain type="primary" @click="cancel">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="confirm">确定</el-button>
    </template>
  </zl-dialog>
</template>

<script>
import store from '@/store'
import memberSelectByTree from '@/components/business/memberSelectByTree.vue'
import { enums } from '@/lib/enum'
let subSystemObj = {}
for (const key in enums.subSystem) {
  if (Object.hasOwnProperty.call(enums.subSystem, key)) {
    subSystemObj[key] = {
      checked: true,
      default: false
    }
  }
}
export default {
  components: {
    memberSelectByTree
  },
  data() {
    var validator = (rule, value, callback) => {
      if (!this.checkedMember || this.checkedMember.length === 0) {
        callback(new Error('成员不能为空'))
      } else {
        callback()
      }
    }
    return {
      enums,
      subSystemObj,
      checkedMember: [],
      form: {
        name: '',
        remark: '',
        chengYuanGuids: ''
      },
      xmChengYuanZuGuid: '',
      rules: {
        name: [{ required: true, message: '分组名称不能为空' }],
        chengYuanGuids: [
          { required: true, message: '成员不能为空', validator: validator }
        ]
      }
    }
  },
  methods: {
    open(args) {
      console.log('arg', args)
      if (args) {
        this.form.remark = args.remark
        this.checkedMember = args.chengYuanGuids.split(',')
        this.xmChengYuanZuGuid = args.xmChengYuanZuGuid
        this.form.name = args.xmChengYuanZuName
      }
      return this.$refs.dialog.open()
    },
    cancel() {
      return this.$refs.dialog.cancel()
    },
    confirm() {
      this.form.chengYuanGuids = this.checkedMember.join(',')

      this.$refs.form.validate((valid) => {
        if (valid) {
          const subSystemCodeStr = []
          const isDefaultStr = []
          for (const key in this.subSystemObj) {
            if (Object.hasOwnProperty.call(this.subSystemObj, key)) {
              if (this.subSystemObj[key].checked) {
                subSystemCodeStr.push(key)
                isDefaultStr.push(this.subSystemObj[key].default ? 1 : 0)
              }
            }
          }
          const params = {
            xmChengYuanZuName: this.form.name,
            chengYuanGuids: this.form.chengYuanGuids,
            subSystemCodeStr: subSystemCodeStr.join(','),
            isDefaultStr: isDefaultStr.join(','),
            remark: this.form.remark,
            creatorGuid: store.state.userInfo.id,
            xmChengYuanZuGuid: this.xmChengYuanZuGuid
          }
          store.dispatch('saveTeamUser', params).then((res) => {
            this.$zl.message.success('保存成功')
            this.$refs.dialog.close()
          })
        }
      })
    }
  }
}
</script>

<style></style>
